import { createStyles, Theme } from '@material-ui/core'
import { colorWhiteAlpha10, transition } from '../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: 100,
      paddingLeft: theme.spacing(0.5),
    },
    menuWrapper: {
      fontSize: 14,
      fontWeight: 600,
      width: '100%',
      [theme.breakpoints.down('md')]: {
        fontSize: 13,
      },
    },
    menuItem: {
      padding: '0 9px',
      color: theme.palette.common.white,
      fontSize: '0.9rem',
      fontWeight: 600,
      textDecoration: 'none',
      [theme.breakpoints.down('md')]: {
        marginLeft: '1em',
      },
    },
    active: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
      textDecoration: 'bold',
      borderRadius: theme.shape.borderRadius,
    },
    menuItemMediumHide: {
      [theme.breakpoints.down(1500)]: {
        display: 'none',
      },
    },
    menuExpandable: {
      display: 'none',
      [theme.breakpoints.down(1500)]: {
        display: 'block',
      },

      [theme.breakpoints.down(968)]: {
        display: 'none',
      },
    },
    menuItemExpandable: {
      margin: '0 9px',
      color: 'black',
      fontSize: '0.9rem',
      fontWeight: 600,
      textDecoration: 'none',
      [theme.breakpoints.down('md')]: {
        marginLeft: '1em',
      },
    },
    menuBlockWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'center',
    },
    menuBlockLeft: {
      marginRight: 'auto',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    menuBlockRight: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginLeft: 'auto',
      [theme.breakpoints.down('md')]: {
        minWidth: 0,
      },
      [theme.breakpoints.down(1140)]: {
        flex: 'initial',
      },
    },
    dropdownMenuIcon: {
      color: theme.palette.common.white,
      display: 'block',
      lineHeight: 1,
      cursor: 'pointer',
      padding: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadius,
      transition: transition,
      '&:hover': {
        backgroundColor: colorWhiteAlpha10,
      },
    },
    dropdownMenu: {
      marginTop: theme.spacing(1),
      minWidth: 220,
      '& .MuiPaper-root': {
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[8],
        border: `1px solid ${theme.palette.divider}`,
        boxSizing: 'border-box',
        padding: theme.spacing(0.5, 1.5),
        overflowX: 'hidden',
        overflowY: 'auto',
      },
      '& .MuiMenuItem-root': {
        padding: theme.spacing(1.25, 2),
        minHeight: 48,
        fontSize: '0.9375rem',
        fontWeight: 600,
        margin: theme.spacing(0.25, 0),
        borderRadius: theme.shape.borderRadius * 2,
        transition: transition,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          transform: 'translateX(4px)',
          '& a': {
            color: theme.palette.common.white,
          },
        },
        '&:active': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '& a': {
        textDecoration: 'none',
        color: theme.palette.text.primary,
        margin: 0,
        minWidth: 0,
        fontWeight: 600,
        fontSize: '0.9375rem',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        transition: transition,
      },
    },
  })
)
